// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/base/web/6457/js/" + chunkId + ".chunk.js";
};